import { render } from "./AboutMalmarket.vue?vue&type=template&id=373c7d3e"
import script from "./AboutMalmarket.vue?vue&type=script&lang=js"
export * from "./AboutMalmarket.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/www-root/data/www/malmarket/malmarket-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__